import React from 'react';
import PropTypes from 'prop-types';
import { GENERIC_NAVIGATION_NAME } from '@johnlewispartnership/wtr-content-component-library/dist/component-library/constants/analyticsNames';
import CategoryLinks from 'components/CategoryLinks';
import CardNav from 'components/Recipes/Content/CardNav';
import propsMapper from './props-mapper';

const cmsCategoryLinksDefaultPropNavigationLinks = [];
const cmsCategoryLinksDefaultPropStyleIds = [];

const CmsCategoryLinks = ({
  navigationLinks = cmsCategoryLinksDefaultPropNavigationLinks,
  navigationTitle = null,
  hideNavigationTitle = false,
  styleIds = cmsCategoryLinksDefaultPropStyleIds,
  showAsCard = false,
  ...rest
}) => {
  const props = {
    navigationLinks,
    navigationTitle,
    hideNavigationTitle,
    styleIds,
    showAsCard,
    ...rest,
  };

  return showAsCard || styleIds.includes('show-as-card') ? (
    <CardNav {...props} />
  ) : (
    <CategoryLinks {...propsMapper(props)} location={{ pathname: '/', search: '/' }} />
  );
};

CmsCategoryLinks.displayName = GENERIC_NAVIGATION_NAME;

CmsCategoryLinks.propTypes = {
  navigationLinks: PropTypes.arrayOf(
    PropTypes.shape({
      path: PropTypes.string,
      title: PropTypes.string,
      categoryId: PropTypes.string,
    }),
  ),
  navigationTitle: PropTypes.string,
  hideNavigationTitle: PropTypes.bool,
  styleIds: PropTypes.arrayOf(PropTypes.string),
  showAsCard: PropTypes.bool,
};

export default CmsCategoryLinks;
